import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  AccessPointConnectable,
  AccessPointServiceProvider,
  AccessPointStatus,
  BuildingType,
  ConnectionState,
  ConstructionStatus,
  DopType,
  EndpointType,
  IAccessPoint,
  IService,
  ServiceType,
  Source,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class AccessPoint
  extends BaseModel<AccessPoint, 'AccessPoint'>
  implements IAccessPoint
{
  static override readonly modelName: AbilitySubjectType = 'AccessPoint';

  sources!: Source[];

  status?: AccessPointStatus;

  eic?: string;

  region?: string;

  county?: string;

  city?: string;

  district?: string;

  street?: string;

  houseNumber?: string;

  houseNumberLocal?: string;

  zip?: string;

  floor?: number;

  flat?: string;

  gpsX?: number;

  gpsY?: number;

  @Type(() => Date)
  connectableEst?: Date;

  @Type(() => Date)
  connectableReal?: Date;

  pbId?: string;

  pbGpsX?: number;

  pbGpsY?: number;

  pbDist?: number;

  fttxId?: string;

  fttxIdActual?: string;

  fttxGpsX?: number;

  fttxGpsY?: number;

  fttxPort?: string;

  fttxDist?: number;

  cableLength?: number;

  endpointType?: EndpointType;

  connectable?: AccessPointConnectable;

  connected?: boolean;

  @Type(() => Date)
  connectedAt?: Date;

  oltName?: string;

  oltFrame?: number;

  oltSlot?: number;

  oltPort?: number;

  ontSn?: string;

  primmarySplitter?: string;

  primmarySplitterGpsX?: number;

  primmarySplitterGpsY?: number;

  @Type(() => Date)
  changeDate?: Date;

  odpRoute?: string;

  odpType?: string;

  @Type(() => Date)
  odpDate?: Date;

  address?: string;

  readonly serviceProviderStatus!: AccessPointServiceProvider;

  readonly connectedStatus!: boolean;

  readonly ssdCanOrder!: boolean;

  readonly ssdCanMigrate!: boolean;

  readonly canOrder?: boolean;

  mapImg?: string | undefined;

  clusterId?: string;

  ontPhoto?: string[];
  dopPhoto?: string[];
  dopRoadPhoto?: string[];
  dopPonmeterPhoto?: string[];
  usedOdb?: string;
  dopPort?: number;
  dopType?: DopType;
  dopRoad?: string;
  dopDbmSignal?: number;

  tv2goAvailable?: boolean;

  availableInternet?: (ServiceType.optic | ServiceType.wifi)[];

  cableTvAvailable?: boolean;

  skylinkAvailable?: boolean;

  availableServices?: ServiceType[];

  locationHash!: string;

  temporary?: boolean;

  oldEic?: string | undefined;
  oldOmId?: string | undefined;
  fsp: string | undefined;

  connectionState!: ConnectionState | null;

  note?: string;

  buildingType?: BuildingType;

  underConstruction?: boolean;

  @Type(() => CustomerAccessPoint)
  customerHistory?: CustomerAccessPoint[];

  activeCustomerId?: number;
  services?: IService[];

  parcel?: string;

  constructionStatus?: ConstructionStatus;
}

export class CustomerAccessPoint {
  customerId!: number;
  apId!: string;
  @Type(() => Date)
  activeFrom!: Date;
  @Type(() => Date)
  inactiveFrom!: Date | null;
  @Type(() => Date)
  closeDate!: Date | null;
  closeType!: string | null;
  @Type(() => Date)
  closeFailedAt!: Date | null;
}
